"use client";
import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface FAQProps {
  question: string;
  answer: string;
}

const FAQList: FAQProps[] = [
  {
    question: "Is this template free?",
    answer: "Yes. It is a free NextJS Shadcn template.",
  },
  {
    question: "Duis aute irure dolor in reprehenderit in voluptate velit?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sint labore quidem quam consectetur sapiente, iste rerum reiciendis animi nihil nostrum sit quo, modi quod.",
  },
  {
    question:
      "Lorem ipsum dolor sit amet Consectetur natus dolor minus quibusdam?",
    answer:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Labore qui nostrum reiciendis veritatis.",
  },
  {
    question: "Excepteur sint occaecat cupidata non proident sunt?",
    answer: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
  },
  {
    question:
      "Enim ad minim veniam, quis nostrud exercitation ullamco laboris?",
    answer: "consectetur adipisicing elit. Sint labore.",
  },
];

export default function FAQ02() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const handleClick = async (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="pb-20 pt-20 md:pb-32 md:pt-32 container mx-auto">
      <div className="grid lg:grid-cols-2 gap-10">
        <div className="flex gap-10 flex-col">
          <div className="flex gap-4 flex-col">
            <div className="text-start space-y-4 pb-4 mx-auto">
              <Badge>FAQ</Badge>
              <h2 className="mx-auto mt-4 text-3xl font-bold sm:text-5xl tracking-tight">
                Frequently asked questions
              </h2>
              <p className="text-xl text-muted-foreground pt-1">
                Managing a small business today is already tough. Avoid
                  further complications by ditching outdated, tedious trade
                  methods.
              </p>
            </div>
            <div className="">
              <h4 className="text-sm font-medium tracking-tight text-foreground/80">
                Still have questions? Email us at{" "}
                <a
                  href="mailto:support@exampe.com"
                  className="underline text-primary"
                >
                  support@exampe.com
                </a>
              </h4>
            </div>
          </div>
        </div>
        <div className="h-fit rounded-lg p-2 border ">
          {FAQList.map((faq, index) => (
            <motion.div
              key={index}
              className={`overflow-hidden ${
                index !== FAQList.length - 1 ? "border-b" : ""
              }`}
              onClick={() => handleClick(index)}
            >
              <button
                className={`p-3 px-2 w-full cursor-pointer sm:text-base text-xs items-center transition-all font-semibold flex gap-2 
               `}
              >
                <Plus
                  className={`${
                    activeIndex === index ? "rotate-45" : "rotate-0 "
                  } transition-transform ease-in-out w-5 h-5  text-gray-600`}
                />
                {faq.question}
              </button>
              <AnimatePresence mode="sync">
                {activeIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeInOut",
                      delay: 0.14,
                    }}
                  >
                    <p
                      className={`p-3 xl:text-base sm:text-sm text-xs pt-0 w-[90%]`}
                    >
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
